import { fetchService } from "./fetchService";
import * as API_PATHS from "utility/api-paths";

export const raiseInquiry = async (from_address: string, subject: string, message: string, name: string): Promise<{ result : string } > => {
  try {
    const data = await fetchService<{ result: string }>(API_PATHS.SEND_INQUIRY_EMAIL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: {
        from_address,
        subject,
        message,
        name
      }
    });
    return data;
  } catch (error: any) {
    throw error;
  }
};
